import { usePage } from '@inertiajs/react'
import { Fragment, type ReactNode } from 'react'
import type { SharedProps } from '../types'

// 三格：版权、备案号、版本号。后两格的值从服务端的共享 props 来（SiteMeta），
// 任一为空就整格连分隔符一起不渲染。
//
// 原来这里读 import.meta.env.VITE_ICP_NUMBER / VITE_VERSION_NUMBER，而那两个
// 变量从来没有人设过 —— Next.js 迁过来时消费者改了名（生产者 bin/deploy.sh
// 至今 export 的还是 NEXT_PUBLIC_*），而且构建从「宿主机上 next build」挪进了
// 镜像，宿主机 export 的变量根本进不去 docker build。于是页脚长期是
// 「© 2026 番茄钟应用 |  | version: 」这个样子，生产也一样。详见 SiteMeta。
export default function Footer() {
  const site = usePage<SharedProps>().props.site

  const segments: { key: string; node: ReactNode }[] = [
    { key: 'copyright', node: <>© {new Date().getFullYear()} 番茄钟应用</> },
  ]

  if (site?.icpNumber) {
    segments.push({
      key: 'icp',
      node: (
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          {site.icpNumber}
        </a>
      ),
    })
  }

  if (site?.version) {
    segments.push({ key: 'version', node: <>version: {site.version}</> })
  }

  return (
    <footer className="bg-white p-4 text-center border-t text-gray-500 text-sm">
      {segments.map(({ key, node }, index) => (
        <Fragment key={key}>
          {index > 0 && <span className="mx-1.5 text-gray-300">|</span>}
          {node}
        </Fragment>
      ))}
    </footer>
  )
}
